exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bottom-cart{\n    bottom:0px;\n    z-index: 10;\n}\n\n", ""]);

// exports
